import PortalExcelletRestRepository from "application/portal/news/excellet/repository/PortalExcelletRestRepository";
import PortalNewsNotiRestRepository from "application/portal/news/noti/repository/PortalNewsNotiRestRepository";
import FaqRestRepository from "application/portal/support/faq/repository/FaqRestRepository";
import TbSysBan from "domain/main/sys/ban/TbSysBan";
import TbSysPop from "domain/main/sys/pop/TbSysPop";
import { action, observable } from "mobx";

import MainModel from "../model/MainModel";
import mainRestRepository from "../repository/MainRestRepository";

/**
 * 메인 Store
 */
class MainStore {
  @observable private _mainModel: MainModel;
  @observable private _scrollHidden: boolean;
  @observable private _mainPopupOpenList: {
    [key: string]: boolean;
  };
  @observable private _todoStsCd: string = "";
  @observable private _todoFromDate!: Date;
  @observable private _todoToDate!: Date;

  public constructor() {
    this._mainModel = new MainModel();
    this._mainPopupOpenList = {};
    this._scrollHidden = false;
  }

  public get mainModel(): MainModel {
    return this._mainModel;
  }
  public get mainPopupOpenList(): {
    [key: string]: boolean;
  } {
    return this._mainPopupOpenList;
  }

  @action
  public setMainPopupOpenList(popupNo: string, openYn: boolean) {
    this._mainPopupOpenList = { ...this._mainPopupOpenList, [popupNo]: openYn };
  }

  public isScrollHidden(): boolean {
    return this._scrollHidden;
  }

  @action
  public setScrollHidden(_scrollHidden: boolean): void {
    this._scrollHidden = _scrollHidden;
  }

  public get todoStsCd(): string {
    return this._todoStsCd;
  }

  public get todoFromDate(): Date {
    return this._todoFromDate;
  }

  public get todoToDate(): Date {
    return this._todoToDate;
  }

  @action
  public setTodoStsCd(todoStsCd: string) {
    this._todoStsCd = todoStsCd;
  }

  @action
  public setToDoFiled(todoStsCd: string, todoFromDate: Date, todoToDate: Date) {
    this._todoStsCd = todoStsCd;
    this._todoFromDate = todoFromDate;
    this._todoToDate = todoToDate;
  }

  /**
   * 게시판, 배너 최근 목록 조회
   */
  public async readBbsLatelyList() {
    const faqRestRepository = new FaqRestRepository("F");
    const portalNewsNotiRestRepository = new PortalNewsNotiRestRepository("N");
    const portalExcelletRestRepository = new PortalExcelletRestRepository();

    const result = await Promise.all([
      faqRestRepository.getLatelyList("F", 3),
      mainRestRepository.getBanList(),
      portalNewsNotiRestRepository.getLatelyList("N", 3),
      portalExcelletRestRepository.getLatelyList(3),
      mainRestRepository.getPopupList(),
    ]);

    if (result != null) {
      this.mainModel.setMainFaqList(result[0]);

      this.mainModel.setMainBannerList(
        result[1]?.map((tbSysBan) => {
          return new TbSysBan(tbSysBan);
        })
      );

      this.mainModel.setMainNewsNotiList(result[2]);
      this.mainModel.setMainNewsExcelletList(result[3]);

      this.mainModel.setMainPopupList(
        result[4]?.map((tbSysPop) => {
          this.setMainPopupOpenList(tbSysPop.popNo, true);
          return new TbSysPop(tbSysPop);
        })
      );
    }
  }
  /**
   * 배너 클릭 수 업데이트
   */
  public async updateBannerClickCount(banNo: string) {
    await mainRestRepository.putBanClkCnt(banNo);
  }
  /**
   * 자주 하는 질문 조회수 업데이트 및 조회
   */
  public async updateCnt(notiNo: string) {
    const faqRestRepository = new FaqRestRepository("F");
    await faqRestRepository.updateCnt(notiNo);
  }
  /**
   * 공지사항 조회수 업데이트 및 조회
   */
  public async updateCntNoti(notiNo: string) {
    const portalNewsNotiRestRepository = new PortalNewsNotiRestRepository("N");
    await portalNewsNotiRestRepository.updateCnt(notiNo);
  }
}

const mainStore = new MainStore();

export default mainStore;
